import MainScene from "./tracking/MainScene";
import Tracking from "./tracking/Tracking";

export default class PagePlayer {
  init(appConfig, wasPlaying) {
    //appConfig.resources[1].camid = "cam5";
    //debugger;
    PagePlayer.that = this;
    this.tracking = new Tracking(appConfig);
    this.tracking.init();
    //console.log(Pqp.lorem(false, 500));
    jQuery(window).on("resize", this.showAndResizeMetaInfo.bind(this));
    //jQuery(window).on("resize", this.checkCoverWidth.bind(this));
    $(".js-btn-3d-video").on("click", this.toggleVideo3d.bind(this, appConfig));
    this.initNav();
  }

  initNav() {
    if (document.querySelector(".btn-toggle-nav") && document.querySelector(".main-nav")) {
      const btn = document.querySelector(".btn-toggle-nav");
      const nav = document.querySelector(".main-nav");
      const navheight = "calc(100vh - 60px)";
      nav.style.height = "0";
      btn.addEventListener("click", (e) => {
        if (btn.classList.contains("is-open")) {
          btn.classList.remove("is-open");
          nav.querySelector(".nav-voicelist").style.opacity = "0";
          nav.style.pointerEvents = "none";
          setTimeout(() => {
            nav.style.height = "0";
          }, 250);
        } else {
          btn.classList.add("is-open");
          nav.style.height = navheight;
          nav.style.pointerEvents = "all";
          setTimeout(() => {
            nav.querySelector(".nav-voicelist").style.opacity = "1";
          }, 250);
        }
      });
    }
  }

  getDimensions() {
    /*  return;
    let hiddenvideo = ".js-video-hidden";
    let visiblevideo = ".js-video-holder";

    const hiddenvideoholder = document.querySelector(".js-video-holder-hidden");
    hiddenvideo = document.querySelector(hiddenvideo);
    visiblevideo = document.querySelector(visiblevideo);
    this.setHiddenVideoContWH(hiddenvideo, visiblevideo, hiddenvideoholder);*/
  }

  // set hidden video-cont width & height equal to visible video-cont
  setHiddenVideoContWH(hiddenvideo, visiblevideo, hiddenvideoholder) {
    /*return;
    const vvw = visiblevideo.querySelector("canvas").offsetWidth;
    const vvh = visiblevideo.querySelector("canvas").offsetHeight;
    hiddenvideo.style.width = vvw + "px";
    hiddenvideo.style.height = vvh + "px";
    if (!hiddenvideoholder.classList.contains("is-visible")) {
      hiddenvideoholder.classList.add("is-visible");
    }*/
  }

  openLayer(data, lFromAnalisi) {
    const layer = document.querySelector(".js-layer-video-alert");
    const bg = layer.querySelector(".js-layer-bg");
    const btnclose = layer.querySelector(".js-close");
    const icon = layer.querySelector(".js-layer-icon");
    const title = layer.querySelector(".js-layer-title");
    const text = layer.querySelector(".js-layer-text");
    const red = "red";
    let idto;

    const { type } = data;

    layer.dataset.type = "type-" + type;

    title.innerText = data.title;
    text.innerHTML = data.desc;

    if (type === 2) {
      layer.classList.remove("layer-type-1");
      layer.classList.remove("layer-type-2");
    } else {
      if (type === 1) {
        layer.classList.remove("layer-type-2");
        layer.classList.add("layer-type-1");
      } else {
        layer.classList.remove("layer-type-1");
        layer.classList.add("layer-type-2");
      }
    }

    layer.removeAttribute("style");
    if (!layer.classList.contains("is-visible")) {
      layer.classList.add("is-visible");
    }

    if (lFromAnalisi) {
      this.idto = setTimeout(() => {
        layer.classList.remove("is-visible");
        MainScene.that.closedLayer(lFromAnalisi);
      }, MainScene.TIME_ANALISI_VISIBILE);
    }

    btnclose.addEventListener("click", (e) => {
      if (layer.classList.contains("is-visible")) {
        layer.classList.remove("is-visible");
        clearTimeout(this.idto);
        MainScene.that.closedLayer(lFromAnalisi);
      }
    });

    const layerbtns = layer.querySelectorAll(".btn");
    for (let i = 0; i < layerbtns.length; i++) {
      layerbtns[i].addEventListener("click", (e) => {
        if (layer.classList.contains("is-visible")) {
          layer.classList.remove("is-visible");
          clearTimeout(this.idto);
          MainScene.that.closedLayer(lFromAnalisi);
        }
      });
    }
  }

  showAndResizeMetaInfo() {
    jQuery(".js-header-copy").removeClass("isHidden");
    const headersCopy = document.querySelectorAll(".js-header-copy");
    if (headersCopy) {
      for (let i = 0; i < headersCopy.length; i++) {
        headersCopy[i].style.width = document.querySelector("canvas").offsetWidth + "px";
      }
    }
  }

  toggleVideo3d(appConfig) {
    jQuery("canvas").remove();
    jQuery(".js-video3d-container").toggleClass("hidden-container");
    $("#player-container").toggleClass("hidden-container");
    const flag = $("#player-container").hasClass("hidden-container");
    if (!flag) {
      this.tracking = new Tracking(appConfig);
      this.tracking.init();
      jQuery(".js-btn-3d-video").text("VEDI VIDEO 3D");
    } else {
      jQuery(".js-btn-3d-video").text("NASCONDI VIDEO 3D");
    }
  }

  checkCoverWidth() {
    // check if width/height ratio is > 1.166
    if (!(window.innerWidth / window.innerHeight > 3.5 / 3)) {
      if (!document.querySelector(".js-page-header").classList.contains("is-not-wide-enough")) {
        document.querySelector(".js-page-header").classList.add("is-not-wide-enough");
      } else {
        document.querySelector(".js-page-header").classList.remove("is-not-wide-enough");
      }
    }
  }
}
